﻿<script>
	export let id;
	export let label;
	export let sublabel = null;
	export let value;
	export let minvalue = null;
	export let maxvalue = null;
	export let maxlength = null;
	export let minlength = null;
	export let placeholder = null;
	export let disabled = null;
	export let readonly = null;
	export let required = null;
	export let errorMessage = null;

	const handleKeyDown = (e) => {
		if (
			e.key == "Backspace" ||
			e.key == "Delete" ||
			e.key == "ArrowLeft" ||
			e.key == "ArrowRight" ||
			e.key === "Enter"
		) {
			return true;
		}
	};

	const handleKeyPress = (e) => {
		if (e.metaKey || e.altKey || e.ctrlKey || e.key === "Enter") {
			return true;
		}

		if (e.key.match(/\d/) || e.key.match(/\./)) {
			const oldValue = value ? value.toString() : null;

			if (
				!(
					oldValue &&
					oldValue.includes &&
					oldValue.includes(".") &&
					oldValue.indexOf(".") === oldValue.length - 3
				)
			) {
				return true;
			}
		}

		e.preventDefault();
		return false;
	};
</script>

{#if label}
	<label for={id}>
		{label}

		{#if required}
			<span class="required">*</span>
		{/if}

		{#if sublabel}
			<div class="sublabel">{sublabel}</div>
		{/if}
	</label>
{/if}
<input
	{required}
	{disabled}
	{readonly}
	{maxlength}
	{minlength}
	{maxvalue}
	{minvalue}
	{placeholder}
	type="number"
	bind:value
	{id}
	class="form-control"
	on:keydown={handleKeyDown}
	on:keypress={handleKeyPress}
	data-bouncer-message={errorMessage}
/>
